import { Card } from "@/components/ui/card";
import SkeletonBar from "./SkeletonBar";

const MailTileSkeleton = () => (
    <Card
        className="pointer-events-none gap-x-4 gap-y-2 overflow-hidden border-2 border-white/30 bg-white/30 shadow-sm"
        display="grid"
        size="1x1"
        variant="read"
    >
        <div className="col-start-1 row-start-1 flex h-37 min-w-0 flex-col gap-3 overflow-hidden">
            <SkeletonBar className="h-3 w-12" />
            <SkeletonBar className="h-5 w-5" round />
            <SkeletonBar className="h-4 w-3/4" />
            <div className="min-h-9 flex-1 rounded-lg bg-surface-primary p-2 pl-4">
                <SkeletonBar className="h-full w-full rounded-md" />
            </div>
        </div>

        <div className="flex h-6 min-w-0 items-center justify-between gap-2 overflow-hidden">
            <SkeletonBar className="h-4 w-16" />
            <SkeletonBar className="h-5 w-5 shrink-0 rounded-sm" />
        </div>
    </Card>
);

export default MailTileSkeleton;
